import APITemplate from '@/api/APITemplate'

export default APITemplate('/service-car')
